/*
 * Enhances Customily controls without replacing its preview or cart workflow.
 */
(() => {
  if (window.__doyoMobileCustomilyPreviewInitialized) return;

  window.__doyoMobileCustomilyPreviewInitialized = true;

  const containerSelector = '[data-doyo-mobile-customily-preview]';
  const triggerSelector = '[data-doyo-mobile-customily-preview-trigger]';
  const customilyPreviewSelector = '#customily-preview-button.customily-preview-button';
  const customilyPreviewWrapperSelector = '.customily-modal-preview-only .main .cl-preview-wrapper';
  const customilyLoadingNoticeSelector = '.doyo-customily-loading-notice';
  const customilyCartButtonSelector = '#customily-cart-btn';
  const customilyRequiredLabelSelector = '.customily-required-label';
  const productFormButtonsSelector = '.doyo-product-form__buttons';
  const readyClass = 'is-ready';
  const bodyClass = 'doyo-has-mobile-customily-preview';
  const debug = (...args) => {
    // console.info('[Doyo Customily]', ...args);
  };

  debug('script initialized');

  const enhancePreviewModals = () => {
    document.querySelectorAll(customilyPreviewWrapperSelector).forEach((wrapper) => {
      if (wrapper.querySelector('.doyo-customily-preview-modal-header')) return;

      const modal = wrapper.closest('.customily-modal-preview-only');
      const main = wrapper.closest('.main');

      modal?.classList.add('doyo-customily-preview-modal-root');
      main?.classList.add('doyo-customily-preview-modal-main');
      wrapper.classList.add('doyo-customily-preview-modal-enhanced');

      const header = document.createElement('div');
      header.className = 'doyo-customily-preview-modal-header';
      header.innerHTML = `
        <div class="doyo-customily-preview-modal-title">Preview your design</div>
        <div class="doyo-customily-preview-modal-subtitle">Please carefully check your design.</div>
      `;

      const addToCartContext = document.createElement('div');
      addToCartContext.className = 'add-to-cart-ctx doyo-customily-preview-add-to-cart';
      addToCartContext.innerHTML =
        '<button type="button" class="add-to-cart-btn button doyo-button" data-doyo-customily-modal-add-to-cart>Add To Cart</button>';

      wrapper.prepend(header);
      wrapper.append(addToCartContext);
    });
  };

  const syncLoadingNotices = (isReady) => {
    document.querySelectorAll(productFormButtonsSelector).forEach((productFormButtons) => {
      const loadingNotice = productFormButtons.querySelector(customilyLoadingNoticeSelector);

      if (isReady) {
        loadingNotice?.remove();
        return;
      }

      if (loadingNotice) return;

      const notice = document.createElement('div');
      notice.className = 'doyo-customily-loading-notice';
      notice.textContent = 'The customization is loading...';
      productFormButtons.prepend(notice);
    });
  };

  const isVisible = (element) => {
    if (!element || element.hidden) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const getCustomilyRequiredWarningCount = () =>
    [...document.querySelectorAll(customilyRequiredLabelSelector)].filter((label) =>
      isVisible(label.querySelector('span') || label)
    ).length;

  const showCustomilyGenerationToast = () => {
    debug('generation toast requested');
    window.setTimeout(() => {
      const requiredWarningCount = getCustomilyRequiredWarningCount();
      debug('generation toast check', {
        requiredLabelCount: document.querySelectorAll(customilyRequiredLabelSelector).length,
        visibleRequiredWarningCount: requiredWarningCount,
      });
      if (requiredWarningCount > 0) {
        debug('generation toast skipped because required validation is visible');
        return;
      }

      document.querySelector('.doyo-customily-generation-toast')?.remove();

      const toast = document.createElement('div');
      toast.className = 'doyo-customily-generation-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = 'Your design is generating, please wait for about 5 seconds…';
      document.body.append(toast);
      debug('generation toast inserted', toast);

      window.setTimeout(() => toast.classList.add('is-hiding'), 5000);
      window.setTimeout(() => toast.remove(), 5500);
    }, 210);
  };

  const sync = () => {
    const customilyPreviewButton = document.querySelector(customilyPreviewSelector);
    const isReady = Boolean(customilyPreviewButton);
    const customilyCartButton = document.querySelector(customilyCartButtonSelector);

    if (isReady || customilyCartButton) {
      debug('sync', {
        previewButton: isReady,
        cartButton: Boolean(customilyCartButton),
        jquery: typeof window.jQuery === 'function',
      });
    }

    document.querySelectorAll(containerSelector).forEach((container) => {
      container.hidden = !isReady;
      container.classList.toggle(readyClass, isReady);
    });

    document.body.classList.toggle(bodyClass, isReady);
    syncLoadingNotices(isReady);
    enhancePreviewModals();
    bindJqueryCartClick();
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest(triggerSelector)) return;

    const customilyPreviewButton = document.querySelector(customilyPreviewSelector);
    if (customilyPreviewButton) customilyPreviewButton.click();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-doyo-customily-modal-add-to-cart]')) return;
    debug('preview modal Add To Cart clicked');

    const customilyCartButton = document.querySelector('#customily-cart-btn');
    const customilyCartTrigger = customilyCartButton?.querySelector('span') || customilyCartButton;
    if (!customilyCartTrigger) {
      debug('preview modal Add To Cart could not find #customily-cart-btn');
      return;
    }

    debug('forwarding preview modal Add To Cart to Customily cart button');
    customilyCartTrigger.click();

    const closeTarget = document.querySelector('cl-is-mobile') || document.querySelector('.customily-close-button');
    if (closeTarget) closeTarget.click();
  });

  const handleCustomilyCartClick = (event) => {
    const nativeEvent = event?.originalEvent || event;
    if (nativeEvent?.__doyoCustomilyGenerationToastHandled) return;
    if (nativeEvent) nativeEvent.__doyoCustomilyGenerationToastHandled = true;

    debug('Customily cart click captured');
    showCustomilyGenerationToast();
  };

  // Capture native clicks even when Customily stops bubbling its own event.
  document.addEventListener('click', (event) => {
    if (!event.target.closest(customilyCartButtonSelector)) return;

    handleCustomilyCartClick();
  }, true);

  // Customily may invoke the cart action through jQuery, which does not emit
  // a native DOM click event for the document listener above.
  const bindJqueryCartClick = () => {
    if (typeof window.jQuery !== 'function') return;
    if (window.__doyoCustomilyJqueryToastBound) return;

    window.__doyoCustomilyJqueryToastBound = true;
    window.jQuery(document).on('click.doyoCustomilyGenerationToast', customilyCartButtonSelector, handleCustomilyCartClick);
    debug('jQuery cart click listener bound');
  };

  new MutationObserver(sync).observe(document.body, {
    childList: true,
    subtree: true,
  });

  sync();
})();
